import React from "react";

const Heading = ({ children }) => {
  return <h4 className="font-bold my-2">{children}</h4>;
};

export default Heading;
